import { AppUpload } from '@components/antd/upload/app-upload';
import { useUploadMultiMedia } from '../hooks/use-upload-media';

export function MultiMediaDragger(props: { uploadMultiMedia: ReturnType<typeof useUploadMultiMedia> }) {
  return (
    <div>
      <AppUpload.DraggerDocument {...props?.uploadMultiMedia?.uploadProps}>
        <AppUpload.DraggerDocumentBody />
      </AppUpload.DraggerDocument>

      {!!props?.uploadMultiMedia?.fileList?.length && (
        <AppUpload.DocumentFileList
          fileList={props?.uploadMultiMedia?.tempFileList}
          handleRemoveClick={props?.uploadMultiMedia?.handleRemoveClick}
        />
      )}
    </div>
  );
}
